import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { User } from 'src/app/shared/models/user.model';
import { NbDialogService, NbTagComponent } from '@nebular/theme';
import { UserService } from 'src/app/shared/service/user.service';
import { finalize, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-general-report-user-filter',
  templateUrl: './general-report-user-filter.component.html',
  styleUrls: ['./general-report-user-filter.component.scss']
})
export class GeneralReportUserFilterComponent implements OnInit {
  @ViewChild('ResultModal') ResultModal: any;
  @Input() cacheKey!: string;
  @Input() single = false;
  @Output() remove = new EventEmitter<User[]>();
  @Output() add = new EventEmitter<User[]>();

  selectedUsers: User[] = [];
  filteredUsers!: User[];
  searchBy: string = 'userID';
  searchQuery!: string;
  fetchUser = false;

  constructor(private userService: UserService, private nbDialgoService: NbDialogService) {
  }

  filter(query: any, type: string): void {
    const filter: any = {
      limit: 100
    };
    if (type === 'email' && typeof query === 'string') {
      filter.email = query;
    }
    if (type === 'phone' && typeof query === 'string') {
      filter.phone = query;
    }
    if (type === 'userID' && typeof query === 'string') {
      filter.id = query;
    }
    if (type === 'nationalID' && typeof query === 'string') {
      filter.national_id = query;
    }
    if (type === 'iban' && typeof query === 'string') {
      filter.iban = query;
    }
    if (type === 'card' && typeof query === 'string') {
      filter.card = query;
    }
    if (type === 'name' && typeof query === 'string') {
      const split = query.split(' ');
      filter.first_name = split[0];
      if (split[1]) {
        filter.last_name = split[1];
      }
    }
    this.fetchUser = true;
    this.userService.getUserList(filter).pipe(take(1)).subscribe(((result) => {
      this.fetchUser = false;
      this.filteredUsers = result;
      if (type === 'userID') {
        this.viewHandleName(result[0]);
      } else {
        this.nbDialgoService.open(this.ResultModal);
      }
    }));
  }

  cacheUsers(): void {
    if (this.cacheKey) {
      localStorage.setItem(this.cacheKey, JSON.stringify(this.selectedUsers));
    }
  }

  viewHandleName(value: string | User): string {
    if (typeof value === 'string') {
      return value;
    }
    if (this.selectedUsers.find((user) => user.id === value.id) === undefined) {
      if (this.single) {
        this.selectedUsers = [value];
      } else {
        this.selectedUsers.push(value);
      }
      this.cacheUsers();
    }
    this.add.emit(this.selectedUsers);
    return '';
  }

  onTagRemove(tag: NbTagComponent): void {
    this.selectedUsers = this.selectedUsers.filter(
      (user) => user.id !== +tag._hostElement.nativeElement.getAttribute('data-delete')
    );
    this.remove.emit(this.selectedUsers);
    this.cacheUsers();
  }

  getCachedUsers(): void {
    if (this.cacheKey) {
      const rawUsers: any[] = JSON.parse(localStorage.getItem(this.cacheKey) ?? '[]');
      this.selectedUsers = rawUsers.map((user) => new User(user));
      this.add.emit(this.selectedUsers);
    }
  }

  ngOnInit(): void {
    this.getCachedUsers();
  }
}
